/*
    Copyright (C) Paul B. Lucas 2025, 2026  ALL RIGHTS RESERVED
    Licensed to the University of Illinois Urbana Champaign

    This is a Javascript composable that is used to check signatures on the Vuex store for user and config.
    If the signature indicates an initial state, the function attempts to reload the user or config
    from localStorage variables.

    This allows the use of the Browser Refresh button as well as any application internal "Back" buttons
    and preserved the brower state.

    User uses netid on local store
    Config used UUID on local store



    <Revision History>
        09-14-2024      pblucas     created 
        03/16/2026      pblucas     Corrected typos & updated copyright    
 
    </Revision History>

    
*/
// imports
import { computed }             from 'vue'
import { store }                from '@/store/store'
  
// composables 
import useConfigAPI                     from '@/composables/useConfigAPI'
import useEmployeesAPI                  from '@/composables/useEmployeesAPI'

const useRefreshAPI = () => {

    const { emplResults, fetchEmployeesOnQuery } = useEmployeesAPI()  
    const { configResults, fetchConfigsOnQuery } = useConfigAPI()

    //  store data
    const user                  =   computed( () => store.state.user)
    const config                =   computed( () => store.state.config)

    //  actions on store
    const setUser           =   (employee) => store.dispatch('setUser', employee)
    const setConfig         =   (config)   => store.dispatch('setConfig', config)
    const setActiveRole     =   (role)     => store.dispatch('setActiveRole', role)

    const checkStoreForRefresh = async () => {

        // test user first
        if(user.value.uuid == "00000000-0000-0000-0000-000000000000") {
            // MARK: Null signature detected - need to reload store from database.
            //       Reload employee on netid
     
            // do process if and only if netid is stored
            let uNetID = localStorage.getItem("user-netid")
            if(uNetID) {
                await fetchEmployeesOnQuery({"netid": uNetID})
                if(emplResults.value.length != 0) {
                    // employee found in database

                    // update store
                    setUser(emplResults.value[0])
                }
            }     
        }

        // now test config
        if(config.value.uuid == "00000000-0000-0000-0000-000000000000") {
            // MARK: Null signature detected - need to reload store from database
            //       Reload config on uuid
            let uuid = localStorage.getItem("config-uuid")
            if(uuid)  {
                fetchConfigsOnQuery({"uuid": uuid})
                .then( () => {
                    // a null object "{}" has length 2
                    if(JSON.stringify(configResults.value).length > 2) {
                        // config found in database
                        // update store
                        setConfig(configResults.value[0])   
                        localStorage.setItem("config-uuid", configResults.value[0].uuid)  
                    }
                    else {
                        // clear the local storage uuid as it is invalid
                        localStorage.removeItem("config-uuid") 
                    }
                })
                
            }
        }   
    }            
    return { checkStoreForRefresh }
}

export default useRefreshAPI
